import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './Components/Home';
import About from './Components/About';
import Services from './Components/Services';
import Contact from './Components/Contact';
import Partner from './Components/Partner';
import Bookride from './Components/Bookride';

import Airport from './Pages/Airport';
import Chauffeur from './Pages/Chauffeur';
import Cityrides from './Pages/Cityrides';
import Rental from './Pages/Rental';
import Greet from './Pages/Greet';
import Booking from './Pages/Booking';

const App = () => {
  return (
    <div className="App">
     

      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path='/About' element={<About/>}/>
        <Route path='/Services' element={<Services/>}/>
        <Route path='/Contact' element={<Contact/>}/>
        <Route path='/Partner' element={<Partner/>}/>
        <Route path='/Bookride' element={<Bookride/>}/>

        <Route path='/Airport' element={<Airport/>}/>
        <Route path='/Chauffeur' element={<Chauffeur/>}/>
        <Route path='/Cityrides' element={<Cityrides/>}/>
        <Route path='/Rental' element={<Rental/>}/>
        <Route path='/Greet' element={<Greet/>}/>
        <Route path='/Booking' element={<Booking/>}/>

      </Routes>

      
    </div>
  );
};

export default App;